import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import DuplicatePurchase from './DuplicatePurchase';
function DuplicatePurchaseOrder() {
  return (
		<div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
			<Helmet>
				<title>Purchase Order - Duplicate</title>
			</Helmet>
			<Header />
			<div
				className="container-fluid maindiv d-flex flex-column"
				style={{ flexGrow: "1" }}
			>
				<DuplicatePurchase />
			</div>
		</div>
	);
}

export default DuplicatePurchaseOrder
